import { getJpRewardInfo, getBetHistory } from "@/lobby_common/api/game_gen";
import { divideAccuracy, divideSymbol } from "@/lobby_common/utils/utils.js";
import { formatTimeToString } from "@/lobby_common/utils/date";
import vueSeamlessScroll from "@/lobby_common/components/vue-seamless-scroll/index.vue";

export default {
  components: {
    vueSeamlessScroll,
  },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formatTimeToString,
      divideSymbol,
      jpValue: 0,
      finalValue: 0,
      list: [],
      listjp: [],
      timer: null,
      coinBase: {},
      coinMap: {},
      emptyCount: 0,
      classOption: {
        // limitMoveNum: 10,
        // step: 0,
        direction: 2,
        openTouch: false,
      },
      classOption1: {
        // limitMoveNum: 10,
        direction: 1,
        openTouch: false,
        singleHeight: 4000,
        // step: 0,
        hoverStop: false,
        limitMoveNum: 2,
      },
      classOptionH5: {
        openTouch: false,
        singleHeight: 29,
        // step: 2,
        direction: 0,
        hoverStop: false,
        limitMoveNum: 2,
      },
    };
  },
  mounted() {
    this.fetchData();
    this.getChooseCurrency();
    this.init();
  },
  computed: {
    formatList() {
      return this.listjp.slice(0, 10);
    },
    formatListjp() {
      return this.listjp.slice(0, 20);
    },
    formatListjp1() {
      return this.listjp.slice(20, 40);
    },
    formatListjp2() {
      return this.listjp.slice(40, 60);
    },
    lang() {
      return this.$store.getters.getLang;
    },
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    application_id() {
      return this.$store.getters.getPacketConfig?.appConfig?.sid;
    },
    platform_id() {
      return this.$store.getters.getPacketDomain?.platformSid;
    },
    coin_accuracy() {
      return this.$store.getters.getPacketConfig?.appConfig?.accuracy
        ? this.$store.getters.getPacketConfig?.appConfig?.accuracy
        : 2;
    },
    coin_code() {
      return this.$store.getters.getPacketConfig?.appConfig?.coinCode;
    },
    coin() {
      const data = {
        ...this.$store.getters.getCurCoin,
        icon: this.$store.getters.getCurCoin?.coinIcon || "",
      };
      if (data && data.icon) return data;
      return this.coinBase;
    },
    getSite() {
      return this.$store.getters.getPacketConfig?.site || {};
    },
    coinList() {
      return this.$store.getters.getPacketConfig?.coinList || [];
    },
    jpBg() {
      // console.log(this.lang, "this.lang", this.item.list[0]?.langInfoObj);
      if (this.item.list[0]?.langInfoObj[this.lang]?.icon) {
        return this.item.list[0]?.langInfoObj[this.lang]?.icon || "";
      } else {
        return this.item.list[0]?.langInfoObj["en"]?.icon || "";
      }
    },
    packetConfig() {
      return this.$store.getters.getPacketConfig?.packetInfo?.baseInfo || {};
    },
    showStyle() {
      if (this.item.list?.length) {
        return this.item.list[0].style || 1;
      }
      return 1;
    },
    titleLeft() {
      return this.item.titleAlignment === 'TITLE_ALIGNMENT_LEFT';
    },
    titleCenter() {
      return this.item.titleAlignment === 'TITLE_ALIGNMENT_CENTER';
    }
  },
  watch: {
    // "coin.coinCode"(n, o) {
    //   // console.log("coin", n, o);
    //   this.fetchData();
    // },
    "$route.path"(n, o) {
      if (n === "/home") {
        // console.log("进入首页");
        this.init();
      }
      if (o === "/home") {
        // console.log("离开首页");
        this.clearTimer();
      }
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    handleParentClick(event) {
      const key = event.target.getAttribute("data-key");
      const item = this.listjp.find((e) => e.key === key);
      if (item) {
        this.$eventPost("click", {
          eid: `101_19_${this.curindex}_0`,
          gameGroupSid: item.gameGroupSid,
          time: Date.now(),
        });
        this.$refs.jpDetailDialog.show(item);
      }
    },
    // 获取可选流通货币
    async getChooseCurrency() {
      this.coinBase =
        this.coinList.find((i) => i.coinCode === this.coin_code) || {};
      // console.log("this.coinBase", this.coinBase);
    },
    clearTimer() {
      this.timer && clearInterval(this.timer);
    },
    async init() {
      const betData = await this.getData();
      let originData = betData.list;
      if (originData.length < 1) {
        this.emptyCount++;
      } else {
        this.emptyCount = 0;
      }

      if (this.emptyCount > 2) {
        this.clearTimer();
        return;
      } // 超过2次没数据就停止轮询

      originData = originData.map((e, i) => {
        const gameInfo = betData.gameInfo[e.gameGroupSid] || {};
        return {
          ...e,
          key: window.crypto.randomUUID(),
          ...gameInfo,
          miniOrH5: gameInfo.gameH5Icon,
          appOrPcUrl: gameInfo.gamePcIcon,
          // gameName: gameInfo.gameName,
          coin_icon: betData.coinIcons[e.coinCode],
          // eid: `101_19_${this.curindex}_${e.gameGroupSid}`,
          // oid: `101_19_${this.curindex}_0`,
        };
      });
      originData = originData.filter(
        (e) => e.miniOrH5 !== "" && e.appOrPcUrl !== ""
      );
      const listlength = this.IsMobile ? 10 : (this.showStyle === 3 ? 60 : 20); // 判断终端去取数据
      const data = originData.splice(0, listlength);
      this.listjp = data;
      // this.$refs.seamlessScroll.reset()
      this.clearTimer();
      this.timer = setInterval(async () => {
        const data1 = originData.shift();
        if (!data1) {
          this.init();
          return;
        }
        this.listjp.push(data1);
        if (this.listjp.length > (this.showStyle === 3 ? 120 : 40)) {
          const listlength1 = this.IsMobile ? 10 : (this.showStyle === 3 ? 60 : 20);
          this.listjp = this.listjp.slice(0, listlength1);
        }
      }, 2000);
    },
    async getData() {
      const res = await getBetHistory({
        limit: 200,
        betType: "JACKPOT",
      });
      if (res.code !== 0) {
        return {
          list: [],
          gameInfo: {},
          coinIcons: {},
        };
      }
      return {
        list: res.data.list || [],
        gameInfo: res.data.gameInfo || {},
        coinIcons: res.data.coinIcons || {},
      };
    },
    fetchData() {
      getJpRewardInfo({}).then((res) => {
        let percent = 1;
        if (this.item.list && this.item.list[0]) {
          const showRatio = this.item.list[0].showRatio || 100;
          percent = showRatio / 100;
          // console.log("percent", percent);
        }
        if (res.code === 0) {
          const obj =
            this.coinList.find((i) => i.coinCode === res.data.coinCode) || {};
          // console.log("obj", obj);
          const totalValue = Number(
            divideAccuracy(
              Number(res.data.jpValue),
              obj.accuracy || this.coin_accuracy
            )
          );
          const finalValue = totalValue * percent;
          // console.log(res.data.jpValue, finalValue);
          let jpValue = finalValue * 0.8; // 初始值
          // 计算时间差值 (当前时间-数据更新时间) / 1000 * 每秒更新值
          const offset =
            ((Date.now() - Number(res.data.updateTime)) / 1000) *
            (finalValue * 0.0001);
          jpValue += offset;
          if (jpValue > finalValue * 0.95) {
            jpValue = finalValue * 0.8;
          }
          this.jpValue = jpValue;
          this.finalValue = finalValue;
        }
      });
    },
  },
};
